import React from 'react'
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import icon from '../assets/Icon.png';
import Patients from "./patients/main.patients";
import Doctors from "./doctors/main.doctors";
import { Hospitales } from "./hospitals/main.hospitals";
import { logout, usuario } from '../resources'
import Admins from './admins/main.admins';
import Receptionists from './receptionists/main.receptionists';
import { BankOutlined, LogoutOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';

const STAFF_PATHS = ['/administradores', '/medicos', '/enfermeros'];

function Navigator() {
  const { pathname } = useLocation();
  return (
    <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/" style={{ fontFamily: 'Poppins' }}>
          <img src={icon} width="40" height="35" className="d-inline-block align-top" alt="Recreamed logo" style={{ marginRight: 8 }} />
          Re-Crea Med
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto" activeKey={pathname}>
            <Nav.Link href="/hospitales" eventKey="/hospitales">
              <BankOutlined style={{ marginRight: 4 }} /> Hospitales
            </Nav.Link>
            <NavDropdown
              title={<><TeamOutlined style={{ marginRight: 4 }} /> Personal</>}
              id="personal-dropdown"
              active={STAFF_PATHS.includes(pathname)}
            >
              <NavDropdown.Item href="/administradores">Administradores</NavDropdown.Item>
              <NavDropdown.Item href="/medicos">Médicos</NavDropdown.Item>
              <NavDropdown.Item href="/enfermeros">Enfermeros</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/pacientes" eventKey="/pacientes">
              <UserOutlined style={{ marginRight: 4 }} /> Pacientes
            </Nav.Link>
          </Nav>
          <Nav>
            <NavDropdown
              title={<><UserOutlined style={{ marginRight: 6 }} />{usuario.name.split(' ')[0]}</>}
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item onClick={logout} style={{ color: '#dc3545' }}>
                <LogoutOutlined style={{ marginRight: 6 }} /> Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default function SuperAdminApp() {
  return (
    <Router>
      <Navigator />
      <Switch>

        <Route path="/hospitales">
          <Hospitales />
        </Route>
        <Route path="/administradores">
          <Admins />
        </Route>
        <Route path="/medicos">
          <Doctors />
        </Route>
        <Route path="/enfermeros">
          <Receptionists />
        </Route>
        <Route path="/pacientes">
          <Patients />
        </Route>
        <Route path="/">
          <Patients />

        </Route>

      </Switch>
    </Router>
  )
}
